import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["easy-is-an-intensity"]!;

export function Body() {
  return (
    <>
      <p>
        An easy run should feel comfortable enough to talk in full sentences. Pace can help
        you keep track, but breathing and effort matter too.
      </p>

      <h2>What easy should feel like</h2>
      <p>
        On an easy run you can talk in full sentences without having to stop for breath. You
        finish feeling that you could have kept going. For many runners the right pace feels
        surprisingly slow at first. That is normal, and it usually feels less odd after a few
        weeks.
      </p>

      <h2>Why the plan includes easy runs</h2>
      <p>
        Easy running makes up most training for elite endurance runners. It builds your aerobic fitness with little fatigue, so you can train often and
        still have energy for the harder sessions in your plan. When easy runs creep up in pace,
        you lose some of that. You get more tired, and the sessions that are meant to be hard
        get harder to do well.
      </p>

      <h2>Using an intensity ceiling</h2>
      <p>
        In PX7 Training an easy run has no minimum pace. Recent race or test data may support
        an upper pace limit, but effort and breathing still matter. If you are tired, if it is hot, or if the route is hilly,
        slow down. Walking a hill is fine too. Running slower than planned on an easy day is
        never a mistake.
      </p>
      <p>
        A faster friend or a good day can tempt you to speed up. Keep the purpose of the run
        in mind. Easy intensity still adds up over time: a very long easy run can be demanding.
      </p>

      <h2>A quick check</h2>
      <p>
        On your next easy run, say a full sentence out loud now and then. If you can do it
        without breaking your rhythm, that is a useful sign that the effort is easy. If the words come in short bursts
        between breaths, slow down.
      </p>
    </>
  );
}
